import { render, staticRenderFns } from "./WelcomeMessageAdded.vue?vue&type=template&id=613e3c16&scoped=true"
import script from "./WelcomeMessageAdded.vue?vue&type=script&lang=js"
export * from "./WelcomeMessageAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613e3c16",
  null
  
)

export default component.exports